import React, { useEffect } from 'react';
import './Header.css';
import img1 from '../../data/img/Group (2).png';
import img2 from '../../data/img/Group.png';
import img3 from '../../data/img/single-meye.png';
import scroll_effect from './../../utils/scroll_effect';

const Header = () => {
    const title = 'We are the solution'
    let i = 0;
    const scrollEffect = () =>{
        if (i < title.length) {
            document.getElementById("title").innerHTML += title.charAt(i);
            if (title.charAt(i) === ' ') {
                i++
                setTimeout(scrollEffect, 200)
            }else{
                i++
            setTimeout(scrollEffect, 80)
            }
            
        }
    }
    useEffect(()=>{
        scrollEffect()
    },[])
    scroll_effect('.img-section', )

    return (
        <>
            <div className='header-button'>
            <p>We are not a revlution neither an evolution</p>
            <div>
                <div className="container">
                    <div>
                        <h1 id='title'></h1>
                        <div>
                            <img className='bitcoin' src={img1} alt=""/>
                            <p>BVarb,com is a company that does arbitrage for the users and partners through very complex software and modern technologgies as arttifical.</p>
                            <div>
                                <img className='bitcoin' src={img2} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className='img-section'>
            <div className="container">
                <img src={img3} alt=""/>
            </div>
        </div>
        </>
    );
};

export default Header;